/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import slugify from "slugify"

import Section from "@components/Section"
import ListingGrid from "@components/ListingGrid"
import TwoColumnSection, {
  Block as ColumnBlock,
  ImageBlock as ColumnImageBlock,
} from "@components/TwoColumnSection"
import { navigate } from "@reach/router"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
import IconThreeUp from "@components/IconThreeUp"
import AccordionWithBanner from "@components/Accordion/WithBanner"
import SEO from "@components/seo"
import Spacer from "@components/Spacers"
import CalloutBlock from "@components/CalloutBlock"
import TestimonialCarousel from "@components/TestimonialCarousel"
const WorkshopListing = ({
  data,
  type,
  pageTitle,
  pathname,
}) => {
  const { carouselTestimonialsNew, accordion, calloutBlock, calloutBlock2, ogdescription, header } = data.pageData.frontmatter

  const isSchool = type === "schools"

  const mapWorkshop = item => ({
    title: item.node.frontmatter.title,
    description: item.node.frontmatter.description,
    image: item.node.frontmatter.image,
    link: `/workshops/${type}/${slugify(
      item.node.frontmatter.title.toLowerCase()
    )}`,
    duration: item.node.frontmatter.duration,
    capacity: item.node.frontmatter.capacity,
    forTeachers: item.node.frontmatter.forTeachers,
  })

  const ELearingCard = {
    title: "Looking for something more virtual?",
    description:
      isSchool ? "Check out our range of bite-sized eLearning options, available to share with your whole cohort." : "Diverse, remote or large workforces require diverse training solutions. Check out our digital, bite-sized eLearning options.",
    link: "/elearning",
    linkText: "Explore eLearning library",
  }

  return (
    <>
      <SEO
        title={pageTitle}
        image={header.headerImage}
        description={ogdescription}
        pathname={pathname}
      />

      <TwoColumnSection
        col1={
          <div>
            <ColumnBlock
              styles={{
                bg: "darkPurple",
                color: "white",
              }}
            >
              <CTAHeadingBlock heading={header.heading} />
            </ColumnBlock>
            <ColumnBlock
              styles={{
                bg: "neonBlue",
                color: "darkPurple",
              }}
            >
              <CTAHeadingBlock
                heading={header.subheading}
                body={header.subtext}
                buttonLabel={header.ctaButton?.label}
                buttonLink={header.ctaButton?.link}
                buttonBg="white"
                buttonColor="darkPurple"
                smallHeading
              />
            </ColumnBlock>
          </div>
        }
        col2={<ColumnImageBlock image={header.headerImage} />}
      />

      {calloutBlock && calloutBlock.text || calloutBlock && calloutBlock.link ? (
        <CalloutBlock
          bannerBg="neonBlue"
          bannerColor="darkPurple"
          cta={{ text: calloutBlock?.ctaLabel, link: calloutBlock?.ctaLink }} image={calloutBlock.image} title={calloutBlock.bannerHeading} heading={calloutBlock.heading} body={calloutBlock.text} />
      ) : null}

      {calloutBlock2 && calloutBlock2.text || calloutBlock2 && calloutBlock2.link ? (
        <CalloutBlock
          bannerBg="neonBlue"
          bannerColor="darkPurple"
          cta={{ text: calloutBlock2?.ctaLabel, link: calloutBlock2?.ctaLink }} image={calloutBlock2.image} title={calloutBlock2.bannerHeading} heading={calloutBlock2.heading} body={calloutBlock2.text} />
      ) : null}

      {carouselTestimonialsNew && carouselTestimonialsNew.items && carouselTestimonialsNew.items.length ? <Section sx={{
        bg: 'white'
      }}>
        <TestimonialCarousel heading={carouselTestimonialsNew.heading} testimonials={carouselTestimonialsNew.items} />
      </Section> : null}


      <TwoColumnSection
        col1={
          <ColumnBlock
            styles={{
              bg: "darkPurple",
              color: "white",
            }}
          >
            <CTAHeadingBlock heading="Have a question?" />
          </ColumnBlock>
        }
        col2={
          <ColumnBlock
            styles={{
              bg: "neonBlue",
              color: "darkPurple",
            }}
          >
            <div>
              <CTAHeadingBlock
                heading="Our team is here to help!"
                body={`If you have a question about ${isSchool ? 'youth' : ''} eLearning or a Speaker for your next event, reach out and we will be in touch.`}
                buttonLink="/learn/enquiry-form"
                buttonLabel="Contact us"
                smallHeading
              />
            </div>
          </ColumnBlock>
        }
      />

    </>
  )
}

export default WorkshopListing
